var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"persistenceKey":'customer-delivery-address-list'}})
}
var staticRenderFns = []

export { render, staticRenderFns }